import { isAxiosError } from 'axios';

import type { ApiErrorResponse } from '@shared/types';

const DEFAULT_ERROR_MESSAGE = 'Щось пішло не так';

export const getApiErrorMessage = (error: unknown): string => {
  if (isAxiosError<ApiErrorResponse>(error)) {
    return error.response?.data?.detail ?? DEFAULT_ERROR_MESSAGE;
  }

  return DEFAULT_ERROR_MESSAGE;
};
